/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type FeeMode = (typeof FeeMode)[keyof typeof FeeMode];

export const FeeMode = {
  PER_ENTRY: "PER_ENTRY",
  PER_PLAYER: "PER_PLAYER",
} as const;
